import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import BaseCommand from './BaseCommand';
import { savePaymentMethodsCommands } from '../../redux/command/command.slice';
import { saveConfigs } from '../../redux/config/config.slice';
import { SharedCommandNames } from '@chegg/commerce-utils';
export var ReauthorizeCommand = /*#__PURE__*/function (_BaseCommand) {
  function ReauthorizeCommand() {
    _classCallCheck(this, ReauthorizeCommand);
    return _callSuper(this, ReauthorizeCommand, arguments);
  }
  _inherits(ReauthorizeCommand, _BaseCommand);
  return _createClass(ReauthorizeCommand, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              response = this.client.authorize(this.input.data);
              if (!this.hasErrors(response.errors)) {
                _context.next = 4;
                break;
              }
              this.callbackErrorsToHost(response.errors, SharedCommandNames.REAUTHORIZE);
              return _context.abrupt("return");
            case 4:
              this.dispatch(savePaymentMethodsCommands([{
                commandName: SharedCommandNames.REAUTHORIZE,
                data: this.input.data
              }]));

              //It's not strictly necessary to update the configs since we won't use it again
              //but it's probably good just make sure it's in sync with current auth credentials
              this.dispatch(saveConfigs({
                authorization: this.input.data
              }));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
}(BaseCommand);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/commandManager/commands/ReauthorizeCommand.js
// module id = 4686
// module chunks = 11